import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

// componet
import { LandList } from "./List/LandList";
import { LoadingComponent } from "../../../components/common/Loading";
import { ErrorComponent } from "../../../components/common/ErrorComponent";

interface RecentlyLandAddedProps {
  data: any[];
  loading: boolean;
  error: string;
}

export const RecentlyLandAdded: FC<RecentlyLandAddedProps> = ({
  data,
  loading,
  error,
}) => {
  const navigate = useNavigate();

  console.log(data)

  const handleListClick = (id: number) => {
    navigate(`/supplier/my-farmers/details-my-farmer/${id}`);
  };

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent message={error} />;
  }

  return (
    <ul style={{ listStyle: "none" }} className="mt-5 p-0">
      {data.map((item: any) => (
        <LandList
          key={item?.id}
          onClick={() => handleListClick(item?.user_id)}
          landName={item?.land_name}
          aggregatorName={item?.userDetails?.aggregator_name}
          userName={item?.userDetails?.name}
        />
      ))}
    </ul>
  );
};
